import ContentLoader from "react-content-loader";

const ProfessionalProfileScreenLoader: React.FC = props => (
	<ContentLoader
		style={{ minWidth: "300" }}
		speed={2}
		width={"100%"}
		height={445}
		viewBox="0 0 300 550"
		backgroundColor="#f3f3f3"
		foregroundColor="#ecebeb"
		{...props}
	>
		<circle cx="150" cy="115" r="65" />
		<rect x="45" y="190" rx="0" ry="0" width="210" height="22" />
		<rect x="35" y="225" rx="0" ry="0" width="230" height="15" />
		<rect x="97" y="251" rx="0" ry="0" width="110" height="19" />
		<rect x="0" y="300" rx="0" ry="0" width="100%" height="14" />
		<rect x="5" y="325" rx="0" ry="0" width="95%" height="14" />
		<rect x="10" y="350" rx="0" ry="0" width="90%" height="14" />
		<rect x="0" y="375" rx="0" ry="0" width="100%" height="14" />
		<rect x="0" y="410" rx="0" ry="0" width="180" height="12" />
		<rect x="0" y="430" rx="0" ry="0" width="190" height="12" />
		<rect x="49" y="475" rx="0" ry="0" width="196" height="50" />
	</ContentLoader>
);

export default ProfessionalProfileScreenLoader;
